"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageSummaryKeyValues = exports.claimsMadeOrOccurrenceOptions = exports.ClaimsMadeOrOccurrence = exports.terrorismRiskInsuranceActTypeOptions = exports.TerrorismRiskInsuranceActType = exports.auditableTypeOptions = exports.AuditableType = exports.coverageTerritoryTypeOptions = exports.CoverageTerritoryType = void 0;
const dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var CoverageTerritoryType;
(function (CoverageTerritoryType) {
    CoverageTerritoryType["DOMESTIC"] = "DOMESTIC";
    CoverageTerritoryType["FOREIGN"] = "FOREIGN";
    CoverageTerritoryType["WORLDWIDE"] = "WORLDWIDE";
    CoverageTerritoryType["UNKNOWN"] = "UNKNOWN";
})(CoverageTerritoryType = exports.CoverageTerritoryType || (exports.CoverageTerritoryType = {}));
exports.coverageTerritoryTypeOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [CoverageTerritoryType.DOMESTIC]: 'Domestic',
    [CoverageTerritoryType.FOREIGN]: 'Foreign',
    [CoverageTerritoryType.WORLDWIDE]: 'Worldwide',
    [CoverageTerritoryType.UNKNOWN]: 'Unknown',
});
var AuditableType;
(function (AuditableType) {
    AuditableType["YES"] = "YES";
    AuditableType["NO"] = "NO";
    AuditableType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    AuditableType["UNKNOWN"] = "UNKNOWN";
})(AuditableType = exports.AuditableType || (exports.AuditableType = {}));
exports.auditableTypeOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [AuditableType.YES]: 'Yes',
    [AuditableType.NO]: 'No',
    [AuditableType.NOT_APPLICABLE]: 'Not applicable',
    [AuditableType.UNKNOWN]: 'Unknown',
});
var TerrorismRiskInsuranceActType;
(function (TerrorismRiskInsuranceActType) {
    TerrorismRiskInsuranceActType["INCLUDED"] = "INCLUDED";
    TerrorismRiskInsuranceActType["NOT_INCLUDED"] = "NOT_INCLUDED";
    TerrorismRiskInsuranceActType["REJECTED"] = "REJECTED";
    TerrorismRiskInsuranceActType["UNKNOWN"] = "UNKNOWN";
})(TerrorismRiskInsuranceActType = exports.TerrorismRiskInsuranceActType || (exports.TerrorismRiskInsuranceActType = {}));
exports.terrorismRiskInsuranceActTypeOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [TerrorismRiskInsuranceActType.INCLUDED]: 'Included',
    [TerrorismRiskInsuranceActType.NOT_INCLUDED]: 'Not included',
    [TerrorismRiskInsuranceActType.REJECTED]: 'Rejected',
    [TerrorismRiskInsuranceActType.UNKNOWN]: 'Unknown',
});
var ClaimsMadeOrOccurrence;
(function (ClaimsMadeOrOccurrence) {
    ClaimsMadeOrOccurrence["CLAIMS_MADE"] = "CLAIMS_MADE";
    ClaimsMadeOrOccurrence["OCCURRENCE"] = "OCCURRENCE";
    ClaimsMadeOrOccurrence["UNKNOWN"] = "UNKNOWN";
})(ClaimsMadeOrOccurrence = exports.ClaimsMadeOrOccurrence || (exports.ClaimsMadeOrOccurrence = {}));
exports.claimsMadeOrOccurrenceOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [ClaimsMadeOrOccurrence.CLAIMS_MADE]: 'Claims-made',
    [ClaimsMadeOrOccurrence.OCCURRENCE]: 'Occurrence',
    [ClaimsMadeOrOccurrence.UNKNOWN]: 'Unknown',
});
exports.LineOfCoverageSummaryKeyValues = [
    'uuid',
    'policyUuid',
    'startDate',
    'endDate',
    'displayName',
    'type',
    'version',
];
//# sourceMappingURL=line-of-coverage.js.map